import { useState, useEffect, useRef } from "react";

import { Buffer } from "buffer";
import { browserName, browserVersion } from "react-device-detect";

import {
	Container,
	Button,
	Toast,
	ToastContainer,
	Accordion,
  	Row,
	Alert
} from "react-bootstrap";
import axios from "axios";

import SwirSatCanvas from "../components/canvas/swir-sat-canvas";
import VnirSatCanvas from "../components/canvas/vnir-sat-canvas";
import SwirRgbCanvas from "../components/canvas/swir-rgb-canvas";
import VnirRgbCanvas from "../components/canvas/vnir-rgb-canvas";
import SpectraPlot from "../components/spectra";


import BrokenImage from "../assets/broken_image.png";

import { Auth } from "aws-amplify";

const QC = (props) => {

	// Set base url for API. No trailing slash. Set for Dev testing, clear for production.
	let base_url = process.env.REACT_APP_QC_API_URL;

	const isMounted = useRef(false);

  	const [error, setError] = useState(false);

	const [count, setCount] = useState(1);
	const [noScanError, setNoScanError] = useState(false);

	const [scanLoaded, setScanLoaded] = useState(false);
  	const [isScanLoading, setIsScanLoading] = useState(false);

	const [noSpectraWarning, setNoSpectraWarning] = useState(false);
	const [qcResultPostSuccess, setQcResultPostSuccess] = useState(false);
	const [qcResultPostFail, setQcResultPostFail] = useState(false);
	const [calpanelheightCheck, setCalPanelHeightCheck] = useState(false);

	const [isSpectraLoading, setIsSpectraLoading] = useState(false);

	// Scan Details
	const [scanName, setScanName] = useState("");
	const [noBoxError, setNoBoxError] = useState(false);

	const [scanType, setScanType] = useState("");

	const [customerPath, setCustomerPath] = useState("");
	const [sitePath, setSitePath] = useState("");
	const [scanTimestamp, setScanTimestamp] = useState("");
	const [scanDetail, setScanDetail] = useState({});
	const [queueName, setQueueName] = useState("");
	const [browserType, setBrowserType] = useState("");
	const [browserVers, setBrowserVers] = useState("");
	const [windowSize, setWindowSize] = useState(getWindowSize());
	const [uuid, setUUID] = useState("");
	const [batchSize, setBatchSize] = useState("");

	// Image State
	const [swirSat, setSwirSat] = useState("");
	const [vnirSat, setVnirSat] = useState("");
	const [swirRgb, setSwirRgb] = useState("");
	const [vnirRgb, setVnirRgb] = useState("");

	// ROI
	const [autoroiPresent, setAutoRoiPresent] = useState(false);
	const [autoRoiCheck, setAutoRoiCheck] = useState(true);
	const [modelName, setModelName] = useState(null);
	
	// Coordinate variables for Auto ROI rectangle
	const [ax1, setax1] = useState(0);
	const [ax2, setax2] = useState(0);
	const [ay1, setay1] = useState(0);
	const [ay2, setay2] = useState(0);

	// Coordinate variables for ROI rectangle
	const [x1, setx1] = useState(0);
	const [x2, setx2] = useState(0);
	const [y1, sety1] = useState(0);
	const [y2, sety2] = useState(0);

	// Wavelengths for Plot
	const [wavelengths, setWavelengths] = useState([]);
	const [upperLeft, setUpperLeft] = useState([]);
	const [upperRight, setUpperRight] = useState([]);
	const [lowerLeft, setLowerLeft] = useState([]);
	const [lowerRight, setLowerRight] = useState([]);
	const [centre, setCentre] = useState([]);

	// Canvas Size
	const [canvasWidth, setCanvasWidth] = useState(0);
	const [canvasHeight, setCanvasHeight] = useState(0);

	const [boxCoordinates, setBoxCoordinates] = useState({});

	const coordinates = (data) => {
		setx1(data.x1);
		setx2(data.x2);
		sety1(data.y1);
		sety2(data.y2);
		// if auto roi doesn't exist for  a scan, set the roi check to null.
		autoroiPresent?setAutoRoiCheck(false): setAutoRoiCheck(null);
	};



	useEffect(() => {
		if ((x1 === 0 && x2 === 0 && y1 === 0 && y2 === 0) || !scanName.toLowerCase().includes("cal")) {
			return
		}
		var cal_height_check_ratio = Number(((y2-y1)/canvasHeight).toFixed(2))
		if (cal_height_check_ratio <= 0.70){
			setCalPanelHeightCheck(true);
		}else{
			setCalPanelHeightCheck(false);
		}

	},[x1])

  /* ******************************************************************************************* */
	useEffect(() => {
    if(!scanLoaded) {
      getNextScan();
    }
	}, []);


  /* ******************************************************************************************* */
	function checkForAutoRoi(scan_name, scan_type, customer_path, site_path) {
		if (scan_type === "Core" && !scan_name.toLowerCase().includes('cal')) {
			console.log("Core Panel Scan - not retrieving auto roi");
			setAutoRoiCheck(false);
		} else {
			console.log("DA Chip Scan - retrieving auto roi");
			getAutoRoi(scan_name, customer_path, site_path);
			setAutoRoiCheck(true);
		}
	}


  /* ******************************************************************************************* */
	async function getNextScan() {
		let idToken = "";
		let user;

    	setIsScanLoading(true);
		setCalPanelHeightCheck(false);

		// Get user
		try {
			const authenticatedUser = await Auth.currentAuthenticatedUser();
			if (authenticatedUser) {
				user = authenticatedUser;
			}
		} catch (error) {
			console.log(error);
      console.log("No User");
			return;
		}

		// Get Id Token
		try {
			const session = await Auth.currentSession();
			if (session) {
				idToken = session.getIdToken().getJwtToken();
			}
		} catch (error) {
			console.log(error);
		}

		setBrowserType(browserName);
		setBrowserVers(browserVersion);

		const browser_metadata = `{"browser_name":"${browserName}", "browser_version":"${browserVersion}", "screenWidth":${windowSize.innerWidth}, "screenHeight":${windowSize.innerHeight}}`;

		const config = {
			url: base_url + "/nextscan",
			method: "get",
			headers: { "token": `${idToken}` },
			params: {
				"browser_metadata": browser_metadata,
				"operator": `${user.username}`,
			},
		};


		axios.request(config).then(function (response) {
      const data = response.data;
      // Set Scan Details
      setScanName(data.scan_name);
      setScanType(data.scan_type);
      setCustomerPath(data.customer_path);
      setSitePath(data.site_path);
      setScanTimestamp(data.scan_timestamp);
      setQueueName(data.queue_name);
      setScanDetail(data.scan_detail);
      setUUID(data.UUID);
      setBatchSize(data.batch_size);

      getImage(data.scan_name, data.customer_path, data.site_path);

      // Check whether there is a need for Auto ROI
      checkForAutoRoi(
        data.scan_name,
        data.scan_type,
        data.customer_path,
        data.site_path
      );
 
	  const scan_detail = data.scan_detail;

      setCanvasWidth(scan_detail.lines);
      setCanvasHeight(scan_detail.samples);

      setScanLoaded(true);
      setIsScanLoading(false);
      setError(false);
    }).catch(function (error) {
      // 404 are expected when to items in queue
      if (error.response.status === 404 ) {
        setNoScanError(true);
        setScanLoaded(false);
        setIsScanLoading(false);
      } else {
        // Seperate Check error when not a 404
        //setNoScanError(true);
        setError(error);
        setQcResultPostFail(true);
        setScanLoaded(false);
        setIsScanLoading(false);
      }

    });
	}

  /* ******************************************************************************************* */
	async function getAutoRoi(scan_name, customer_path, site_path) {
		let idToken = "";
		try {
			const session = await Auth.currentSession();
			if (session) {
				idToken = session.getIdToken().getJwtToken();
			}
		} catch (error) {
			console.log(error);
		}

		const config = {
			url: base_url + "/roi",
			method: "get",
			headers: { "token": `${idToken}` },
			params: {
				"scan_name": scan_name,
				"customer_path": customer_path,
				"site_path": site_path,
			},
		};

		axios.request(config).then(function (response) {
				const data = response.data;
				//set the auto_roi_present state
				if (data.x1 != 0 && data.x2 != 0 && data.y1 != 0 && data.y2 != 0) {
					// Set model name
					setModelName(data.model_name);
					setAutoRoiPresent(true);
				}else{
					setAutoRoiPresent(false);
				}
				// Set Auto ROI Canvas Coordinates
				setax1(data.x1);
				setax2(data.x2);
				setay1(data.y1);
				setay2(data.y2);
				// Set SWIR SAT, VNIR RGB, SWIR RGB Canvas Coordinates
				setx1(data.x1);
				setx2(data.x2);
				sety1(data.y1);
				sety2(data.y2);				
			}).catch(function (error) {
				console.log(error);
			});
	}


  /* ******************************************************************************************* */
	async function getImage(scan_name, customer_path, site_path) {
		let idToken = "";

		try {
			const session = await Auth.currentSession();
			if (session) {
				idToken = session.getIdToken().getJwtToken();
			}
		} catch (error) {
			console.log(error);
		}

		const config = {
			url: base_url + "/scanimages",
			method: "get",
			headers: { "token": `${idToken}` },
			params: {
				"scan_name": scan_name,
				"customer_path": customer_path,
				"site_path": site_path
			}
		};

		axios.request(config).then(function (response) {
			
			setSwirRgb(`data:image/png;charset=utf-8;base64,${response.data[0]}`);
			setSwirSat(`data:image/png;charset=utf-8;base64,${response.data[1]}`);
			setVnirRgb(`data:image/png;charset=utf-8;base64,${response.data[2]}`);
			setVnirSat(`data:image/png;charset=utf-8;base64,${response.data[3]}`);
			
    }).catch(function (error) {

			setSwirRgb(BrokenImage);
			setSwirSat(BrokenImage);
			setVnirRgb(BrokenImage);
			setVnirSat(BrokenImage);
      console.log(error);
    });
	}


  /* ******************************************************************************************* */
	async function getSpectra() {
		// Skip if no points
		if (x1 === 0 && x2 === 0 && y1 === 0 && y2 === 0) {
			console.log("Spectra called with no points");
			return;
		}

		setIsSpectraLoading(true);

		let idToken = "";

		try {
			const session = await Auth.currentSession();
			if (session) {
				idToken = session.getIdToken().getJwtToken();
			}
		} catch (error) {
			console.log(error);
		}

		const config = {
			url: base_url + "/spectra",
			method: "get",
			headers: { "token": `${idToken}` },
			params: {
				"scan_name": scanName,
				"site_path": sitePath,
				"customer_path": customerPath,
				"png_coordinates": { "x1": x1, "y1": y1, "x2": x2, "y2": y2 },
			},
		};

		axios.request(config).then(function (response) {
      setIsSpectraLoading(false);
      const data = response.data;
      // Set Spectra Data
      setUpperLeft(data.upper_left);
      setUpperRight(data.upper_right);
      setCentre(data.centre);
      setLowerLeft(data.lower_left);
      setLowerRight(data.lower_right);
      setWavelengths(data.wavelengths);
      setBoxCoordinates(data.coordinates);

    }).catch(function (error) {
      setIsSpectraLoading(false);

      // Clear Spectra Data
      setUpperLeft(null);
      setUpperRight(null);
      setCentre(null);
      setLowerLeft(null);
      setLowerRight(null);
      setWavelengths(null);
      setBoxCoordinates(null);

      if (error.response.status === 404) {
        setNoSpectraWarning(true);
      }
      if (error.response.status === 406) {
        setNoSpectraWarning(true);
      }

      setNoSpectraWarning(true);
    });
	}


	/* ******************************************************************************************* */
	async function handleScanPass() {
		if (x1 === 0 && x2 === 0 && y1 === 0 && y2 === 0) {
			console.log("Pass called with no points. Error!");
			setNoBoxError(true);
			return;
		}

		let idToken = "";
		let user;

		var line_min;
		var line_max;
		var sample_min;
		var sample_max;

		// Get user
		try {
			const authenticatedUser = await Auth.currentAuthenticatedUser();
			if (authenticatedUser) {
				user = authenticatedUser;
			}
		} catch (error) {
			console.log(error);
		}

		// Get Id Token
		try {
			const session = await Auth.currentSession();
			if (session) {
				idToken = session.getIdToken().getJwtToken();
			}
		} catch (error) {
			console.log(error);
		}

		scanDetail["qc_result_source"] = "manualqc";
		scanDetail["qc_result"] = "pass";
		


		if (scanType === "Core" && !scanName.toLowerCase().includes("cal")) {
			line_min = 0;
			line_max = canvasWidth;

			sample_min = 0;
			sample_max = canvasHeight;
		} else {
			
			line_min = `${canvasWidth - Math.max(x1, x2)}`;
			line_max = `${canvasWidth - Math.min(x1, x2)}`;

			sample_min = `${Math.min(y1, y2)}`;
			sample_max = `${Math.max(y1, y2)}`;
		}

		scanDetail["auto_roi_accepted"] = `${autoRoiCheck}`;
		scanDetail['auto_roi_present'] = `${autoroiPresent}`;
		scanDetail["roi"] = {
			"rectangles": [
				{
					"type": "envi",
					"name": autoRoiCheck ? "auto_rectangle_1" : "user_rectangle_1",
					"line_min": line_min,
					"line_max": line_max,
					"sample_min": sample_min,
					"sample_max": sample_max,
				},
			],
		}
		scanDetail["model_name"] = `${modelName}`

		// original_roi
		
		if (autoRoiCheck){
			scanDetail["original_roi"] = scanDetail['roi']
		}else if (autoroiPresent && !autoRoiCheck){
			scanDetail["original_roi"] = {
				"rectangles": [
					{
						"type": "envi",
						"name": autoRoiCheck ? "auto_rectangle_1" : "user_rectangle_1",
						"line_min": `${canvasWidth - Math.max(ax1, ax2)}`,
						"line_max": `${canvasWidth - Math.min(ax1, ax2)}`,
						"sample_min": `${Math.min(ay1, ay2)}`,
						"sample_max": `${Math.max(ay1, ay2)}`,
					},
				],
			}	
		}else if (!autoroiPresent) {
			scanDetail["original_roi"] = null
		}
		//redrawn roi
		if (autoRoiCheck){
			scanDetail["redrawn_roi"] = null
		}else{
			scanDetail["redrawn_roi"] = scanDetail['roi']
		}

		const messages = `{"result":"pass", "operator":"${user.username}"}`;
		const config = {
			url: base_url + "/qcresult",
			method: "post",
			headers: { "token": `${idToken}` },
			data: {
				"scan_name": scanName,
				"site_path": sitePath,
				"customer_path": customerPath,
				"scan_timestamp": scanTimestamp,
				"operation": "QC",
				"messages": messages,
				"scan_details": scanDetail,
				"queue_name": queueName,
				"browser_metadata": `{"browser_name":"${browserType}", "browser_version":"${browserVers}", "screenWidth":${windowSize.innerWidth}, "screenHeight":${windowSize.innerHeight}}`,
				"UUID": `${uuid}`,
			},
		};

		axios.request(config).then(function (response) {
        setQcResultPostSuccess(true);
        clearScanData();
			})
			.catch(function (error) {
				setQcResultPostFail(true);
				console.log(error);
			});
	}

  /* ******************************************************************************************* */
	async function handleScanFail() {
		let idToken = "";
		let user;
		
		var line_min;
		var line_max;
		var sample_min;
		var sample_max;

		// Get user
		try {
			const authenticatedUser = await Auth.currentAuthenticatedUser();
			if (authenticatedUser) {
				user = authenticatedUser;
			}
		} catch (error) {
			console.log(error);
		}

		// Get Id Token
		try {
			const session = await Auth.currentSession();
			if (session) {
				idToken = session.getIdToken().getJwtToken();
			}
		} catch (error) {
			console.log(error);
		}

		scanDetail["qc_result_source"] = "manualqc";
		scanDetail["qc_result"] = "fail";

		if (scanType === "Core" && !scanName.toLowerCase().includes("cal")) {
			line_min = 0;
			line_max = canvasWidth;

			sample_min = 0;
			sample_max = canvasHeight;
		} else {
			// TODO: block the pass button, until a reactngle is drawn by the user.
			line_min = `${canvasWidth - Math.max(x1, x2)}`;
			line_max = `${canvasWidth - Math.min(x1, x2)}`;

			sample_min = `${Math.min(y1, y2)}`;
			sample_max = `${Math.max(y1, y2)}`;
		}

		scanDetail["auto_roi_accepted"] = autoroiPresent?"false":null; 
		scanDetail['auto_roi_present'] = `${autoroiPresent}`;
		
		scanDetail["roi"] = {
			"rectangles": [
				{
					"type": "envi",
					"name": autoRoiCheck ? "auto_rectangle_1" : "user_rectangle_1",
					"line_min": line_min,
					"line_max": line_max,
					"sample_min": sample_min,
					"sample_max": sample_max,
				},
			],
		}
		scanDetail["model_name"] = `${modelName}`

		// original_roi
		if (!autoroiPresent && autoRoiCheck){
			// applicable only when failing the scan.
			//if there is scan with no auto roi and user wants to fail the scan before drawing a box
			scanDetail["original_roi"] = null;
			scanDetail["roi"] = null;
		}else if (autoRoiCheck){
			scanDetail["original_roi"] = scanDetail['roi']
		}else if (autoroiPresent && !autoRoiCheck){
			scanDetail["original_roi"] = {
				"rectangles": [
					{
						"type": "envi",
						"name": autoRoiCheck ? "auto_rectangle_1" : "user_rectangle_1",
						"line_min": `${canvasWidth - Math.max(ax1, ax2)}`,
						"line_max": `${canvasWidth - Math.min(ax1, ax2)}`,
						"sample_min": `${Math.min(ay1, ay2)}`,
						"sample_max": `${Math.max(ay1, ay2)}`,
					},
				],
			}	
		}else if (!autoroiPresent) {
			scanDetail["original_roi"] = null
		}
		
		//redrawn roi
		if (autoRoiCheck){
			scanDetail["redrawn_roi"] = null
		}else{
			scanDetail["redrawn_roi"] = scanDetail['roi']
		}

		const messages = `{"result":"fail", "operator":"${user.username}"}`;

		const config = {
			url: base_url + "/qcresult",
			method: "post",
			headers: { "token": `${idToken}` },
			data: {
				"scan_name": scanName,
				"site_path": sitePath,
				"customer_path": customerPath,
				"scan_timestamp": scanTimestamp,
				"operation": "QC",
				"messages": messages,
				"scan_details": scanDetail,
				"queue_name": queueName,
				"browser_metadata": `{"browser_name":"${browserType}", "browser_version":"${browserVers}", "screenWidth":${windowSize.innerWidth}, "screenHeight":${windowSize.innerHeight}}`,
				"UUID": `${uuid}`,
			},
		};

		axios.request(config).then(function (response) {
      setQcResultPostSuccess(true);
      clearScanData();
    }).catch(function (error) {
      setQcResultPostFail(true);
      console.log(error);
    });
	}

/* ******************************************************************************************* */
function clearScanData() {
  setScanName("");

  setCount(count + 1);
  // Clear Spectra Plot
  setUpperLeft([]);
  setUpperRight([]);
  setCentre([]);
  setLowerLeft([]);
  setLowerRight([]);
  setWavelengths([]);

  // Clear Images
  setSwirSat();
	setVnirSat("");
	setSwirRgb("");
	setVnirRgb("");

  // THT: The following dont seem to help much. Adding for completeness
  coordinates({
    "x1": 0,
    "y1": 0,
    "x2": 0,
    "y2": 0,
    "auto_roi": false,
  });

  // Set Auto ROI Canvas Coordinates
  setax1(null);
  setax2(null);
  setay1(null);
  setay2(null);
  // Set SWIR SAT, VNIR RGB, SWIR RGB Canvas Coordinates
  setx1(null);
  setx2(null);
  sety1(null);
  sety2(null);

  setBoxCoordinates({});

  // Load next Scan
  getNextScan();
}


/* ******************************************************************************************* */
	async function handleScanSkip() {
		let idToken = "";

		try {
			const session = await Auth.currentSession();
			if (session) {
				idToken = session.getIdToken().getJwtToken();
			}
		} catch (error) {
			console.log(error);
		}

		const config = {
			url: base_url + "/skipscan",
			method: "post",
			headers: { "token": `${idToken}` },
			params: {
				"scan_name": scanName,
				"site_path": sitePath,
				"customer_path": customerPath,
				"queue_name": queueName,
				"UUID": `${uuid}`,
				"scan_type": scanType,
			},
		};

		axios.request(config).then(function (response) {
        clearScanData();
			})
			.catch(function (error) {
				console.log(error);
			});
	}


/* ******************************************************************************************* */
	function getWindowSize() {
		const { innerWidth, innerHeight } = window;
		return { innerWidth, innerHeight };
	}

/* ******************************************************************************************* */
	useEffect(() => {
		function handleWindowResize() {
			setWindowSize(getWindowSize());
		}

		window.addEventListener("resize", handleWindowResize);

		return () => {
			window.removeEventListener("resize", handleWindowResize);
		};
	}, []);



/* ******************************************************************************************* */
	useEffect(() => {
		if (isMounted.current) {
      // Dont get null spectra (after scan change)
      if( x1 && y1 && x2 && y2 ) {
        getSpectra();
      }
		} else {
			isMounted.current = true;
		}
		//eslint-disable-next-line
	}, [x1, y1, x2, y2]);


/* ******************************************************************************************* */
	function ScanLoadedScreen() {


		return (
			<>
				<Container style={{ marginTop: "15px", marginBottom: "5px" }}>
					<div style={{ textAlign: "center" }}>
						<Button
							variant="outline-danger"
							style={{ minWidth: "100px", height: "40px" }}
							onClick={handleScanFail}
              disabled={isScanLoading || isSpectraLoading}
						>
							Fail Scan
						</Button>{" "}
						<Button
							variant="outline-warning"
							style={{ minWidth: "100px", height: "40px" }}
							onClick={handleScanSkip}
              disabled={isScanLoading || isSpectraLoading}
						>
							Skip Scan
						</Button>{" "}
						<Button
							variant="outline-success"
							style={{ minWidth: "100px", height: "40px" }}
							onClick={handleScanPass}
              disabled={isScanLoading || isSpectraLoading}
						>
							Pass Scan
						</Button>{" "}
					</div>
				</Container>
				<br />
				<Container style={{ marginTop: "15px", marginBottom: "10px" }}>
					<h3 style={{ textAlign: "center" }}>
						{scanName} ({scanType})
					</h3>
				</Container>
				<Container
					style={{
						maxWidth: "1500px",
						marginTop: "10px",
						marginBottom: "10px",
					}}
				>
					<Accordion defaultActiveKey={["0"]} alwaysOpen>
						<Accordion.Item eventKey="0">
							<Accordion.Header> Saturation Images</Accordion.Header>
							<Accordion.Body>
								<div className={"scanHolder" + scanType}>
									<div className="scanTitle">Vnir Saturation Image</div>
									<VnirSatCanvas
										width={canvasWidth}
										height={canvasHeight}
										func={coordinates}
										model_name={modelName}
										ax1={ax1}
										ax2={ax2}
										ay1={ay1}
										ay2={ay2}
										x1={x1}
										x2={x2}
										y1={y1}
										y2={y2}
										img={vnirSat}
										type={scanType}
										coordinates={boxCoordinates}
                    disableBox={isSpectraLoading}
									/>
								</div>
								<div className={"scanHolder" + scanType}>
									<div className="scanTitle">Swir Saturation Image</div>
									<SwirSatCanvas
										width={canvasWidth}
										height={canvasHeight}
										x1={x1}
										x2={x2}
										y1={y1}
										y2={y2}
										img={swirSat}
										type={scanType}
									/>
								</div>
							</Accordion.Body>
						</Accordion.Item>
						<Accordion.Item eventKey="1">
							<Accordion.Header>RGB Images</Accordion.Header>
							<Accordion.Body>
								<div className={"scanHolder" + scanType}>
									<div className="scanTitle">Vnir RGB Image</div>
									<VnirRgbCanvas
										width={canvasWidth}
										height={canvasHeight}
										x1={x1}
										x2={x2}
										y1={y1}
										y2={y2}
										img={vnirRgb}
										type={scanType}
									/>
								</div>
								<div className={"scanHolder" + scanType}>
									<div className="scanTitle">Swir RGB Image</div>
									<SwirRgbCanvas
										width={canvasWidth}
										height={canvasHeight}
										x1={x1}
										x2={x2}
										y1={y1}
										y2={y2}
										img={swirRgb}
										type={scanType}
									/>
								</div>
							</Accordion.Body>
						</Accordion.Item>
					</Accordion>


          <SpectraPlot
            isLoading={isSpectraLoading}
            wavelengths={wavelengths}
            upperRight={upperRight}
            upperLeft={upperLeft}
            lowerRight={lowerRight}
            lowerLeft={lowerLeft}
            centre={centre}
          />

				</Container>

			</>
		);
	}

  /* ******************************************************************************************* */
	function NoScanErrorScreen() {
		return (
      <Container style={{ marginTop: "15px", marginBottom: "5px" }}>
        <Row>
        <h1 style={{ textAlign: "center" }}> No more Scans in queue</h1>
        <div style={{ textAlign: "center" }}>
          <p>Add more scans to the queue and refresh.</p>
          <Button
            variant="success"
            onClick={getNextScan}
          >
            Refresh
          </Button>

        </div>
        </Row>

      </Container>
		);
	}

  /* ******************************************************************************************* */
	function NoAPIErrorScreen() {
		return (
      <Container style={{ marginTop: "15px", marginBottom: "5px" }}>
        <Row>
        <h1>QC API Error</h1>
        <p>Bad response from QC API.</p>
        <p>Check that QC API is up and running, then try again.</p>
        </Row>
      </Container>
		);
	}

  /* ******************************************************************************************* */
	function ScanLoadingScreen() {

    return (
			<>
				<Container style={{ marginTop: "15px", marginBottom: "5px" }}>
					<h1 style={{ textAlign: "center" }}> Loading Scan...</h1>
				</Container>
			</>
		);
	}

/* ******************************************************************************************* */
  function ScanContent(user) {

    if (error) {
      return (
        <NoAPIErrorScreen/>
      )
    } else if (isScanLoading) {
      return (
        <ScanLoadingScreen/>
      )
    } else if (scanLoaded) {
      return (
        <ScanLoadedScreen/>
      )
    } else {
      return (
        <NoScanErrorScreen/>
      )
    }
  }


  return (
    <>

    <ScanContent user={props.user} />

	<Alert 
		variant="warning"
		show={calpanelheightCheck}
		onClose={() => setCalPanelHeightCheck(false)}
		style={{
			position: 'absolute',
			top: '175px',
			left: '50%',
			transform: 'translateX(-50%)',
			zIndex: 9999,
			padding: '8px',
			fontSize: '14px'
		}}
		>
			Please redraw the Cal Panel ROI to cover the entire height of the Cal Panel 
    </Alert>


    <div style={{ position: "fixed", bottom: 0, right: 0, zIndex: 9999 }}>
      <ToastContainer>
        <Toast
          onClose={() => setNoScanError(false)}
          bg="danger"
          show={noScanError}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Error</strong>
          </Toast.Header>
          <Toast.Body>No more scans available for QC!</Toast.Body>
        </Toast>

        <Toast
          onClose={() => setNoSpectraWarning(false)}
          bg="warning"
          show={noSpectraWarning}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Warning</strong>
          </Toast.Header>
          <Toast.Body>No spectra found. Draw new ROI!</Toast.Body>
        </Toast>

        <Toast
          onClose={() => setQcResultPostSuccess(false)}
          bg="success"
          show={qcResultPostSuccess}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Success</strong>
          </Toast.Header>
          <Toast.Body>QC has been successfully posted!</Toast.Body>
        </Toast>

        <Toast
          onClose={() => setQcResultPostFail(false)}
          bg="secondary"
          show={qcResultPostFail}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">QC API Error</strong>
          </Toast.Header>
          <Toast.Body>
            Error Contacting the QC API.
            Please refresh the web page.
          </Toast.Body>
        </Toast>

        <Toast
          onClose={() => setNoBoxError(false)}
          bg="secondary"
          show={noBoxError}
          delay={3000}
          autohide
        >

        <Toast.Header>
            <strong className="me-auto">No Pass Scan!</strong>
          </Toast.Header>
          <Toast.Body>Select an area before passing a scan.</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
    </>
  )
}

export default QC;